var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 14,
    viewBox: "0 0 72 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.03 13.255L4.635 8.485L0.765 5.89H5.505L7.2 0.774999L8.925 5.89H13.635L9.765 8.485L11.4 13.255L7.2 10.21L3.03 13.255ZM17.4294 13.255L19.0344 8.485L15.1644 5.89H19.9044L21.5994 0.774999L23.3244 5.89H28.0344L24.1644 8.485L25.7994 13.255L21.5994 10.21L17.4294 13.255ZM31.8288 13.255L33.4338 8.485L29.5638 5.89H34.3038L35.9988 0.774999L37.7238 5.89H42.4338L38.5638 8.485L40.1988 13.255L35.9988 10.21L31.8288 13.255ZM46.2282 13.255L47.8332 8.485L43.9632 5.89H48.7032L50.3982 0.774999L52.1232 5.89H56.8332L52.9632 8.485L54.5982 13.255L50.3982 10.21L46.2282 13.255ZM60.6277 13.255L62.2327 8.485L58.3627 5.89H63.1027L64.7977 0.774999L66.5227 5.89H71.2327L67.3627 8.485L68.9977 13.255L64.7977 10.21L60.6277 13.255Z",
    fill: "#F0AD4E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRate);
export default __webpack_public_path__ + "static/media/rate.2fa663350856899ce520d9d76a6c3db6.svg";
export { ForwardRef as ReactComponent };